import React from "react";
import { PageHeader, TeamMember } from "../../components";
import DartGallery from "./directory/dart";

export default function Dart() {
  return (
    <div className="page-content">
      <PageHeader title="Darts" page="darts" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          {/* <!-- Our Awesome Services --> */}
          <div className="section-full bg-gray content-inner ">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center section-head mamber-dec">
                  <h3 className="h2">WELCOME TO DARTS</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <div className="clear"></div>
                  <h5 class="font-weight-3 m-b30">
                    Welcome to the Darts Section of Lagos Country Club—fondly
                    known as The Mecca of Darts. Our newly refurbished Darts
                    Hall, Members’ Lounge, and Upper Lounge (also called the
                    Cool Room) provide the perfect environment for recreation,
                    relaxation, and social engagement.
                  </h5>
                  <h5>
                    At the heart of our section is the love for darts and
                    vibrant social interaction. We offer a welcoming,
                    family-friendly atmosphere where members can enjoy friendly
                    competition, unwind, and connect with fellow enthusiasts.
                  </h5>
                  <h5>
                    As part of our commitment to nurturing future champions, we
                    actively encourage youth participation in darts—promoting
                    mental focus, strategic thinking, and healthy competition.
                    Whether you're a current member or considering joining the
                    Lagos Country Club, the Darts Section is a fantastic choice
                    for fun, fellowship, and fitness of the mind.
                  </h5>

                  <h5>Visit us today—you’ll love what you see.</h5>
                  {/* <a href="/#" className="site-button">Learn More</a> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!-- About Company END --> */}

          <DartGallery />
          {/* <!-- Team member --> */}
          <TeamMember
            name="EVANG ADEKUNBI AKIN-TAYLOR"
            title="LCC CHAIRMAN DARTS"
            img="./assets/images/members/LCC_CHAIRMAN_DARTS.jpg"
          />
          {/* <!-- Team member --> */}
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
